export default "__VITE_ASSET__807e3c61__"